import { usePathname, useRouter, useSearchParams } from 'next/navigation.js';
import { type ActiveOverviewParams } from '../types.ts';

export const useActiveOverviewDrawerParams = (): [
  ActiveOverviewParams | undefined,
  (params: ActiveOverviewParams | undefined) => void,
] => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const overviewId = searchParams.get('overviewId');
  const params = overviewId ? { id: overviewId } : undefined;

  const setParams = (newParams: ActiveOverviewParams | undefined) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    if (newParams) {
      newSearchParams.append('overviewId', String(newParams.id));
    } else {
      newSearchParams.delete('overviewId');
    }

    if (newSearchParams.size > 0) {
      router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    } else {
      router.push(pathname, { scroll: false });
    }
  };

  return [params, setParams];
};
